import * as type from "../action-types";

type load = { id: string }

export const getSectorsAction = (payload?: load) => ({
    type: type.GET_SECTORS
});
